import React from 'react';

interface PlanTagProps {
  planName: string;
  price: number;
  size?: 'small' | 'medium' | 'large';
}

const PlanTag: React.FC<PlanTagProps> = ({ planName, price, size = 'small' }) => {
  const getPlanColors = (name: string) => {
    // Cores padrão cinza para todos os planos, igual ao hover dos menus da sidebar
    return {
      bg: 'bg-gray-100',
      text: 'text-gray-700',
      border: 'border-gray-300',
      dark: {
        bg: 'bg-gray-700/40',
        text: 'text-gray-300',
        border: 'border-gray-600'
      }
    };
  };


  const getSizeClasses = (size: string) => {
    switch (size) {
      case 'small':
        return 'px-1 py-0.5 text-[10px] font-medium'; // Padding maior, texto pequeno
      case 'medium':
        return 'px-1.5 py-0.5 text-xs font-semibold'; // Compacto para dropdown
      case 'large':
        return 'px-2 py-0.5 text-sm font-bold';      // Médio
      default:
        return 'px-1 py-0.5 text-[10px] font-medium'; // Padrão ajustado
    }
  };

  const colors = getPlanColors(planName);
  const sizeClasses = getSizeClasses(size);

  return (
    <div
      className={`
        inline-flex items-center gap-1 rounded-full border
        ${colors.bg} ${colors.text} ${colors.border}
        ${sizeClasses}
        transition-all duration-200 hover:scale-105
      `}
    >
      <span className="leading-none font-medium">
        {planName}
      </span>
    </div>
  );
};

export default PlanTag;